import React from 'react'
import { HeadingXS, TitleMD } from '@/atoms/Text'

interface Props {
  title: string
  subtitle: string
}

const SectionHeading: React.FC<Props> = ({ title, subtitle }) => {
  return (
    <div className="px-6 md:px-8 lg:px-12 2xl:px-[4.5rem]">
      <HeadingXS weight="semibold" className="lg:photon-heading-sm mb-2">
        {title}
      </HeadingXS>
      <TitleMD color="core-gray-400" weight="normal" className="lg:photon-title-lg mb-8">
        {subtitle}
      </TitleMD>
    </div>
  )
}

export default SectionHeading
